<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="postData"
      label-position="right"
      label-width="150px"
      class="form"
    >
      <el-form-item label="难度名称" prop="difficulty_name">
        <el-input
          v-model="postData.difficulty_name"
          maxlength="32"
          show-word-limit
          clearable
          placeholder="请输入 2 ~ 32 字符的难度名称"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.courseDifficultyList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/course-difficulty';

export default {
  name: RouteConfig.courseDifficultyEdit.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    postData: {
      update_time: 0,
      difficulty_name: '',
    },
    rules: {
      difficulty_name: [{ required: true, message: '请输入难度名称', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const { isError } = await update(this.id, this.postData);
        this.isSaving = false;
        if (!isError) RouteConfig.courseDifficultyList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { postData } = this;
      const newPostData = {};
      Object.keys(data).forEach(key => {
        if (key in postData) newPostData[key] = data[key];
      });
      Object.assign(postData, newPostData);
    },
  },
};
</script>
